import { useState } from 'react';
import { Button, Tag } from 'primereact';
import React, { useEffect } from 'react'


import Card from '../../../../Base/Components/Card/Card';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';



import { getInventarioHilazaMensual } from '../../../../API/Produccion/BodegaHilaza/BodegaHilazaRequests';

import { colorCotton, colorSintetico } from '../../../../Styles/Colors';
import { ArchivosExcelService } from '../../../../Base/Services/ArchivosService';

export const InventarioMensualHilazaScreen = () => {


    const [inventario, setInventario] = useState([]);
    const [loading, setLoading] = useState(false);
    const [select, setSelect] = useState([])

    useEffect(() => {
        window.document.title = 'PPF • Bodega Hilaza';
    }, [])

    const categoryHilazaTemplate = (rowData) => {
        switch (rowData.StyleCategory) {
            case 'Cotton':
                return <Tag severity='danger' className='col-12' value="Cotton" style={{ backgroundColor: colorCotton }}/>
                break;
            case 'Synthetic':
                return <Tag severity='info' className='col-12' value="Synthetic" style={{ backgroundColor: colorSintetico }}/>
                break;
            case 'Spandex':
                return <Tag className='col-12' value="Spandex" style={{ backgroundColor: '#ffc605' }} />
                break;
        
            default:
                return <div>{rowData.StyleCategory}</div>
                break;
        }
    }

    const columns = [
        {
            header: 'Producto',
            headerName: 'Producto',
            children: [
                {
                    header: 'Codigo Producto',
                    field: 'CodigoProducto',
                    className: 'medium',
                    frozen: true,
                    
                },
                {
                    header: 'Categoria',
                    field: 'StyleCategory',
                    className: 'Xsmall',
                    Format: 'Template',
                    body: categoryHilazaTemplate
                },
                {
                    header: 'Hilaza',
                    field: 'Hilaza',
                    className: 'XXlarge',
                    Sumary: 'count',
                    frozen: true,
                },

            ]
        },
        {
            header: 'Fecha Recibida',
            field: 'FechaRecibidaText',
            Format: 'DateTime'
        },
        // {
        //     header: 'FechaCreacion',
        //     field: 'FechaCreacionText',
        //     Fomat: 'DateTime'
        // },
        {
            header: 'Cliente',
            field: 'Cliente',
            className: 'XXlarge'
        },
        {
            header: 'Factura',
            field: 'Factura',
            className: 'large'
        },
        {
            header: 'Lote Hilaza',
            field: 'LoteHilaza',
            className: 'small'
        },
        {
            header: 'Estado QC',
            field: 'EstadoQC',
            className: 'small'
        },

        // {
        //     header: 'SemanaHilo',
        //     field: 'SemanaHilo',
        // },
        // {
        //     header: 'Contenedor',
        //     field: 'Contenedor',
        // },
        // {
        //     header: 'Ubicacion',
        //     field: 'Ubicacion',
        // },
        {
            header: 'Terminos',
            field: 'Terminos',
            className: 'small'
        },
        {
            header: 'Tipo Uso',
            field: 'TipoUso',
            className: 'small'
        },
        {
            header: 'Categoria Ingreso',
            field: 'CategoriaIngreso',
            className: 'small'
        },
        {
            header: 'Tipo Ingreso',
            field: 'TipoIngreso',
            className: 'small'
        },
        // {
        //     header: 'Orden Ingreso',
        //     field: 'OrdenIngreso',
        //     className: 'small'
        // },
        // {
        //     header: 'PO Cliente',
        //     field: 'POCliente',
        // },
        {
            header: 'SalesOrder',
            field: 'SalesOrder',
        },
        {
            header: 'Estado',
            field: 'Estado',
            className: 'medium'
        },
        // {
        //     header: 'KnittingContract',
        //     field: 'KnittingContract',
        // },
        // {
        //     header: 'Dias',
        //     field: 'Dias',
        // },
        // {
        //     header: 'EstadoPlaning',
        //     field: 'EstadoPlanning',
        // },
        {
            header: 'Aging',
            field: 'Aging',
            className: 'small'
        },
        {
            header: 'IngresadoPor',
            field: 'IngresadoPor',
            className: 'Xlarge'
        },
        {
            header: 'Comentarios',
            field: 'Comentarios',
            className: 'Xlarge'
        },
        {
            header: 'QtyLbs',
            field: 'QtyLbs',
            className: 'small',
            Format: 'Decimal',
        },
        {
            header: 'Lot Number',
            field: 'LotNumber2',
            className: 'Xlarge'
        },
        {
            header: 'Reciclado',
            field: 'Reciclado',
            className: 'small',
            Format: 'Checkbox'
        },
        {
            header: 'Conos',
            field: 'Conos',
            className: 'small',
            Format: 'Decimal'
        },
        {
            headerName: 'Datos Hilaza',
            header: 'Hilaza',
            children: [
                {
                    header: 'Origen',
                    field: 'Origen',
                    className: 'small'
                },
                {
                    header: 'Fabricante',
                    field: 'Fabricante',
                    className: 'XXlarge'
                },
                {
                    header: 'Proveedor',
                    field: 'Proveedor',
                    className: 'XXlarge'
                },
            ]
        },
        {
            headerName: 'Calidad',
            header: 'Calidad',
            children: [
                {
                    header: 'Fecha',
                    field: 'DateQCText',
                },

                {
                    header: 'Optico',
                    field: 'OpticoQC',
                    Format: 'Checkbox',
                    className: 'Xsmall'
                },
                // {
                //     header: 'DefectoQC',
                //     field: 'DefectoQC',
                // },
                // {
                //     header: 'CondicionQC',
                //     field: 'CondicionQC',
                // },
                // {
                //     header: 'CommentsQC',
                //     field: 'CommentsQC',
                // },
            ]
        },
        {
            headerName: 'Hold',
            header: 'Hold',
            children: [
                {
                    header: 'Hold',
                    field: 'Hold',
                    Format: 'Checkbox',
                    className: 'Xsmall'
                },
                // {
                //     header: 'ComentarioHold',
                //     field: 'ComentarioHold',
                // },
            ]
        },
        {
            headerName: 'Planning',
            header: 'Planning',
            children: [
                {
                    header: 'Estado Planning',
                    field: 'EstadoPlanning',
                },
                {
                    header: 'Comentario',
                    field: 'CommentsPla',
                },

            ]
        },
        {
            headerName: 'Inicial',
            header: 'Inicial',
            children: [
                {
                    header: 'Kgs',
                    field: 'Inicial',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Ingresos',
            header: 'Ingresos',
            children: [
                {
                    header: 'Kgs',
                    field: 'IngKgs',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'IngresosDev',
            header: 'Ingresos',
            children: [
                {
                    header: 'Kgs',
                    field: 'DIngKgs',
                    className: 'small',
                    Format: 'Decimal', 
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Salidas',
            header: 'Salidas',
            children: [
                {
                    header: 'Kgs',
                    field: 'RSalKgs',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
            ]
        },
        {
            headerName: 'Inventario',
            header: 'Inventario',
            children: [
                {
                    header: 'Box',
                    field: 'InvBox',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
                {
                    header: 'Kgs',
                    field: 'InvKgs',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
                {
                    header: 'Price',
                    field: 'Price',
                    className: 'small',
                    Format: 'Decimal',
                },
                {
                    header: 'Monto',
                    field: 'Monto',
                    className: 'small',
                    Format: 'Decimal',
                    Sumary: 'sum',
                },
            ]
        },

    ]


    const table = {
        Columns: columns,
        Data: inventario,
        loading: loading,
        selected: select,
        setSelected: setSelect
    }


    const getInfo = async () => {
        setLoading(true)
        const a = await getInventarioHilazaMensual();
        setInventario(a)
        setLoading(false)
    }

    const exportarExcel = () => {
        const t = inventario.map(i => {
             return {
               Categoria: i.StyleCategory,
               Hilaza: i.Hilaza,
               "Fecha Recibida": i.FechaRecibida,
               Factura: i.Factura,
               "Lote Hilaza": i.LoteHilaza,
               "Estado QC": i.EstadoQC,
               Terminos: i.Terminos,
               "Tipo uso": i.TipoUso,
               "Categoria Ingreso": i.CategoriaIngreso,
               "Tipo Ingreso": i.TipoIngreso,
               "Sales Order": i.SalesOrder,
               Estado: i.Estado,
               Aging: i.Aging,
               "Ingresado por": i.IngresadoPor,
               Comentarios: i.Comentarios,
               QtyLbs: i.QtyLbs,
               "Lot Number": i.LotNumber2,
               Reciclado: i.Reciclado,
               Conos: i.Conos,
               Origen: i.Origen,
               Fabricante: i.Fabricante,
               Proveedor: i.Proveedor,
               Calidad: i.Calidad,
               "Fecha Calidad": i.DateQCText,
               Optico: i.Optico,
               Hold: i.Hold,
               "Estado Planning": i.EstadoPlanning,
               "Comentario Planning": i.CommentsPla,
               "Inicial (kg)": i.Inicial,
               "Ingresos (kg)": i.IngKgs,
               "IngresosDev (kg)": i.DIngKgs,
               "Salidas (kg)": i.RSalKgs,
               Box: i.InvBox,
               Kgs: i.InvKgs,
               Price: i.Price,
               Monto: i.Monto
             }
        })
        ArchivosExcelService(t, 'Inventario Hilaza Mensual ')
     }


     useEffect(() => {
        window.document.title = 'PPF • Inventario Hilaza Mensual';
        getInfo()
    }, [])



    return (
        <div className='p-3'>
            <Card
                titulo={<div className='d-flex'>
                    <h3>Inventario Hilaza Mensual</h3>
                    <div className='mx-2'>
                        <Button icon={'pi pi-refresh'} className='p-button-info mx-2' onClick={e => getInfo()} />
                        <Button icon={'pi pi-file-excel'} className='p-button-success' onClick={e => exportarExcel()} />
                    </div>
                </div>}

                contenido={<div className='p-4' style={{ height: '85vh' }}>
                    <AgGrid table={table} />
                </div>}
            />

        </div>
    )
}

export default InventarioMensualHilazaScreen